import * as Sentry from '@sentry/vue'
import { isKnownDataLayerContractValid } from '@/utils/constants/dataLayerContracts'

export function pushToDataLayer(data: object) {
  if (import.meta.server) return

  // @ts-expect-error dataLayer doesn't exist until it is included as script in nuxt.config
  window.dataLayer = window?.dataLayer || []
  // @ts-expect-error dataLayer doesn't exist until it is included as script in nuxt.config
  window.dataLayer.push(data)
}

interface IValidatableDataLayerPayload {
  event: string
  event_category: string
  page_type: string
}

function reportRejectedDataLayerPayload(reason: string, data: IValidatableDataLayerPayload) {
  console.error(`[dataLayer] Rejected payload: ${reason}`, data)

  Sentry.captureException(new Error(`dataLayer payload rejected: ${reason}`), {
    tags: {
      feature: 'data-layer'
    },
    extra: {
      event: data.event,
      event_category: data.event_category,
      page_type: data.page_type
    }
  })
}

export function pushValidatedDataLayer<T extends IValidatableDataLayerPayload>(data: T) {
  if (!data.event || !data.event_category || !data.page_type) {
    reportRejectedDataLayerPayload('missing required field(s) (event, event_category or page_type)', data)
    return
  }

  if (!isKnownDataLayerContractValid(data)) {
    reportRejectedDataLayerPayload('event/event_category does not match the known contract for this page_type', data)
    return
  }

  pushToDataLayer(data)
}
